import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right";
import { useLineItemsListSections } from "@/pages/(app)/returns/refund/hooks/use-line-items-list-sections";
import useLineItemsQuantitiesSummary from "@/pages/(app)/returns/refund/hooks/use-line-items-quantities-summary";
import {
  useSetValidatedByLogistician,
  useValidatedByLogistician,
} from "@/pages/(app)/returns/refund/hooks/use-line-items-state-context";
import { useRefundLineItem } from "@/pages/(app)/returns/refund/hooks/use-refund-line-items-context";
import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import { Badge } from "@babackapp/ui/components/badge";
import NumberFlow from "@number-flow/react";
import { ArticleItem } from "../article-item/article-item";
import { getMaxQuantityValidated } from "./use-refund.view-model";

export default function ArticlesValidatedByLogistician() {
  const t = useTranslation();
  const { itemsValidatedByLogistician } = useLineItemsListSections();
  const hasPermissionToView = useViewerHasAtLeastAdminRights();
  const summary = useLineItemsQuantitiesSummary({
    state: "validated-by-logistician",
  });

  if (!itemsValidatedByLogistician.length || !hasPermissionToView) {
    return null;
  }

  return (
    <AccordionItem value="validatedByLogistician">
      <AccordionTrigger>
        <span>
          {t("returnDetail.confirmModal.validatedByLogistician")}
          <Badge variant="secondary" className="ml-2">
            <NumberFlow value={summary.selected} suffix={` / ${summary.max}`} />
          </Badge>
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="border-border border rounded-md flex-col gap-4 divide-y overflow-hidden">
          {itemsValidatedByLogistician.map((lineItem) => (
            <ValidatedByLogisticianArticle
              key={lineItem.line_item_id}
              lineItem={lineItem}
            />
          ))}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}

function ValidatedByLogisticianArticle({
  lineItem,
}: {
  lineItem: ReturnRequestLineItemDto;
}) {
  const { item, updateResolution, updateVariant } = useRefundLineItem(lineItem);
  const quantityValue = useValidatedByLogistician(lineItem.line_item_id);
  const updateQuantity = useSetValidatedByLogistician(lineItem.line_item_id);
  return (
    <ArticleItem
      lineItem={item}
      quantity={quantityValue.selectedQuantity}
      maxQuantity={getMaxQuantityValidated(lineItem)}
      onChangeQuantity={updateQuantity}
      onChangeVariant={updateVariant}
      onChangeResolution={updateResolution}
      hideStatus
    />
  );
}
